/**
 * The URL the page was loaded at, captured before the router can change it.
 *
 * Google's web sign-in popup lands back on the site root (`<origin>/#access_token=...`),
 * because Google only accepts a redirect URI registered exactly. The web SocialLogin plugin
 * that reads those tokens is imported lazily, so by the time it runs, the root route may
 * already have navigated away and dropped the hash. index.tsx imports this module before
 * App so the value is taken while the address bar is still untouched.
 */
export const landingUrl = window.location.href;
